module.exports = new __parcel__URL__("atlassian-intelligence-dark.87b71d6e.svg").toString();